/**
 * Add an `afterShow` option to jQuery.datapicker to complement the existing `beforeShow` option.
 */
(function(datepicker) {
	'use strict';

	var originalFn = datepicker._updateDatepicker;

	datepicker._updateDatepicker = function(inst) {

		originalFn.apply(this, arguments);

		var afterShow = this._get(inst, 'afterShow');
		if (afterShow) {
			var input = inst.input ? inst.input[0] : null;
			afterShow.call(input, input, this);
		}

	};

}(jQuery.datepicker.constructor.prototype));
